import React from 'react';
import {IRoutableModule} from '../../../router/routing.infra';
import {EntryView} from './entry.view';
import {DashboardLayout} from '../views/layout/DashboardLayout';

import '../views/DashboardNewView.scss';
import {entryRouteLoader} from './entry.loader';

const DashboardEntryDesktopView = () => (
    <div className='dashboard-container ts-horizontal-layout bright-dashboard'>
        <DashboardLayout>
            <EntryView />
        </DashboardLayout>
    </div>
);

const DashboardEntryMobileView = () => (
    <div className='dashboard-container ts-horizontal-layout bright-dashboard'>
        <EntryView />
    </div>
);

export default {
    loader: entryRouteLoader,
    Component: DashboardEntryDesktopView,
    MobileComponent: DashboardEntryMobileView,
    storeAs: 'entryStore'
} as IRoutableModule;
